/* Dynasty theme \u2014 vanilla JS. No dependencies. */
(() => {
  'use strict';
  const D = window.Dynasty || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const track = (event, payload) => { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event }, payload || {})); } catch (e) {} };
  const money = (cents) => {
    try { return new Intl.NumberFormat(D.locale || 'en', { style: 'currency', currency: D.currency || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- Cart ---------- */
  const setCartCount = (n) => $$('[data-cart-count]').forEach(el => { el.textContent = n; });
  async function addToCart(items) {
    const res = await fetch(D.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
    const cart = await fetch(D.routes.cart, { headers: { Accept: 'application/json' } }).then(r => r.json());
    setCartCount(cart.item_count);
    document.dispatchEvent(new CustomEvent('dynasty:cart-updated', { detail: cart }));
    return cart;
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    const mains = $$('[data-gallery-main]', root);
    $$('[data-gallery-thumb]', root).forEach(btn => btn.addEventListener('click', () => {
      const i = btn.dataset.galleryThumb;
      mains.forEach(m => { m.hidden = m.dataset.galleryMain !== i; });
      $$('[data-gallery-thumb]', root).forEach(b => b.setAttribute('aria-current', String(b === btn)));
    }));
  }

  /* ---------- Buy box ---------- */
  const buyboxes = [];
  function initBuybox(root) {
    const form = $('[data-buy-form]', root) || $('form', root);
    const idInput = $('[data-variant-input]', root);
    const qtyInput = $('[data-qty-input]', root);
    const qtyOut = $('[data-qty]', root);
    const atc = $('[data-atc]', root);
    const err = $('[data-error]', root);
    const ship = $('[data-ship-line]', root);
    const note = $('[data-sample-note]', root);
    const opts = $$('[data-option]', root);
    let qty = 1, busy = false, resetT;

    const current = () => opts.find(o => o.getAttribute('aria-checked') === 'true') || opts[0];
    const state = () => {
      const o = current();
      return o ? { id: o.dataset.variantId, price: +o.dataset.price, sticks: +o.dataset.sticks || 0, sample: o.dataset.sample === 'true', short: o.dataset.short, available: !o.disabled } : null;
    };
    const render = () => {
      const s = state(); if (!s) return;
      idInput.value = s.id; qtyInput.value = qty; qtyOut.textContent = qty;
      if (!busy) atc.textContent = s.available ? 'Add to cart \u00b7 ' + money(s.price * qty) : 'Sold out';
      atc.disabled = !s.available;
      if (note) note.hidden = !s.sample;
      if (ship) {
        const free = D.freeShipCents > 0 ? 'Free shipping on orders ' + money(D.freeShipCents).replace(/\.00$/, '') + '+' : '';
        ship.textContent = (s.sample || (D.freeShipCents > 0 && s.price * qty >= D.freeShipCents)) ? 'This order ships free' : free;
      }
      root.dispatchEvent(new CustomEvent('dynasty:buybox-change', { detail: s, bubbles: true }));
    };
    // Show the option's own photo (Products > variant > image) in the gallery beside this buy box
    const gallery = (root.closest('[data-size-stack]') || root.closest('section') || document).querySelector('[data-gallery]');
    const showMedia = (o) => {
      if (!gallery || !o || !o.dataset.mediaId) return;
      const mains = $$('[data-gallery-main]', gallery);
      const hit = mains.find(m => m.dataset.mediaId === o.dataset.mediaId);
      if (!hit) return;
      mains.forEach(m => { m.hidden = m !== hit; });
      $$('[data-gallery-thumb]', gallery).forEach(t => t.setAttribute('aria-current', String(t.dataset.galleryThumb === hit.dataset.galleryMain)));
    };
    const select = (o) => {
      if (!o || o.disabled) return;
      opts.forEach(x => x.setAttribute('aria-checked', String(x === o)));
      track('option_selected', { option: o.dataset.short });
      showMedia(o);
      render();
    };
    opts.forEach(o => o.addEventListener('click', () => select(o)));
    // Arrow-key navigation for the radiogroup
    root.addEventListener('keydown', (e) => {
      if (!e.target.matches('[data-option]') || !['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].includes(e.key)) return;
      e.preventDefault();
      const enabled = opts.filter(o => !o.disabled);
      let i = enabled.indexOf(e.target) + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1);
      i = (i + enabled.length) % enabled.length;
      enabled[i].focus(); select(enabled[i]);
    });
    $('[data-qty-inc]', root).addEventListener('click', () => { qty++; render(); });
    $('[data-qty-dec]', root).addEventListener('click', () => { qty = Math.max(1, qty - 1); render(); });

    const flash = (label) => {
      atc.textContent = label;
      clearTimeout(resetT);
      resetT = setTimeout(() => { busy = false; render(); }, 1800);
    };
    const submit = async (items, eventName) => {
      if (busy) return;
      busy = true; err.hidden = true; atc.disabled = true;
      try {
        await addToCart(items);
        track('add_to_cart', eventName);
        atc.disabled = false;
        flash('Added to cart \u2713');
        root.dispatchEvent(new CustomEvent('dynasty:added', { bubbles: true }));
      } catch (e) {
        busy = false; atc.disabled = false; err.textContent = e.message; err.hidden = false; render();
      }
    };
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const s = state(); if (!s) return;
      submit([{ id: +s.id, quantity: qty }], { option: s.short, qty });
    });
    const starter = $('[data-starter]', root);
    if (starter) starter.addEventListener('click', () => {
      const ids = starter.dataset.starter.split(',');
      submit(ids.map(id => ({ id: +id, quantity: 1 })), { option: 'starter' });
    });

    // ?pick=sample preselects the sample (used by the hero's "Try 4 sticks" link)
    const pick = new URLSearchParams(location.search).get('pick');
    if (pick) {
      const o = opts.find(x => (pick === 'sample' && x.dataset.sample === 'true') || (x.dataset.short || '').toLowerCase().includes(pick.toLowerCase()));
      if (o) opts.forEach(x => x.setAttribute('aria-checked', String(x === o)));
    }
    showMedia(current());
    render();
    const api = { root, state, qty: () => qty, submit: () => form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })), atc };
    buyboxes.push(api);
    return api;
  }

  /* ---------- Sticky add-to-cart (product page) ---------- */
  function initSticky() {
    const bar = $('[data-sticky-atc]');
    const box = buyboxes[0];
    if (!bar || !box) return;
    const meta = $('[data-sticky-meta]', bar);
    const btn = $('[data-sticky-btn]', bar);
    const update = () => {
      const s = box.state(); if (!s) return;
      meta.textContent = [s.short, s.sticks > 0 ? money(Math.round(s.price / s.sticks)) + '/stick' : money(s.price)].filter(Boolean).join(' \u00b7 ');
    };
    box.root.addEventListener('dynasty:buybox-change', update);
    box.root.addEventListener('dynasty:added', () => { btn.textContent = 'Added \u2713'; setTimeout(() => { btn.textContent = 'Add to cart'; }, 1800); });
    btn.addEventListener('click', () => box.submit());
    update();
    const io = new IntersectionObserver(([en]) => {
      const past = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', past);
      bar.setAttribute('aria-hidden', String(!past));
      btn.tabIndex = past ? 0 : -1;
    });
    io.observe(box.atc);
  }

  /* ---------- Modals ---------- */
  let lastFocus = null;
  const openModals = () => $$('[data-modal]:not([hidden])');
  function openModal(id) {
    const m = document.getElementById(id);
    if (!m) return;
    lastFocus = document.activeElement;
    m.hidden = false;
    document.body.classList.add('dy-lock');
    const f = $('[data-modal-close]', m) || m;
    setTimeout(() => f.focus(), 30);
    updateMobileBar();
  }
  function closeModal(m) {
    if (!m || m.hidden) return;
    m.hidden = true;
    if (m.id === 'dy-clip') $('[data-clip-media]', m).innerHTML = '';
    if (m.id === 'dy-quiz') store.set('dyn_quiz_done', '1');
    if (!openModals().length) document.body.classList.remove('dy-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    updateMobileBar();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openModal(opener.dataset.open); return; }
    const closer = e.target.closest('[data-modal-close]');
    if (closer) { closeModal(closer.closest('[data-modal]')); return; }
    const m = e.target.closest('[data-modal]');
    if (m && !e.target.closest('[data-modal-panel]')) closeModal(m);
  });
  document.addEventListener('keydown', (e) => {
    const open = openModals();
    if (!open.length) return;
    const m = open[open.length - 1];
    if (e.key === 'Escape') { closeModal(m); return; }
    if (e.key === 'Tab') { // focus trap
      const f = $$('a[href],button:not([disabled]),input,textarea,select,iframe,video,[tabindex]:not([tabindex="-1"])', m).filter(el => !el.closest('[hidden]'));
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Wingwoman clips */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-clip]');
    if (!b) return;
    const modal = $('#dy-clip');
    const tpl = document.getElementById(b.dataset.clip);
    if (!modal || !tpl) return;
    $('[data-clip-media]', modal).innerHTML = '';
    $('[data-clip-media]', modal).appendChild(tpl.content.cloneNode(true));
    $('[data-clip-name]', modal).textContent = b.dataset.clipName || '';
    $('[data-clip-meta]', modal).textContent = b.dataset.clipMeta || '';
    track('wingwoman_clip', { name: b.dataset.clipName });
    openModal('dy-clip');
  });

  /* ---------- Welcome quiz ---------- */
  function initQuiz() {
    const m = $('[data-quiz]');
    if (!m) return;
    const cfg = D.quiz || {};
    const steps = $$('[data-quiz-step]', m);
    const dots = $$('[data-quiz-dot]', m);
    const opts = $$('[data-quiz-opt]', m);
    const all = $('[data-quiz-all]', m);
    const next = $('[data-quiz-next]', m);
    const form = $('[data-quiz-form]', m) || $('form', m);
    const fallback = JSON.parse(($('[data-quiz-default]') || {}).textContent || '{}');
    let fired = false;

    const go = (n) => {
      steps.forEach(s => { s.hidden = +s.dataset.quizStep !== n; });
      dots.forEach(d => d.classList.toggle('is-on', +d.dataset.quizDot <= n));
    };
    const selected = () => opts.filter(o => o.getAttribute('aria-pressed') === 'true');
    const sync = () => {
      const sel = selected();
      if (all) all.setAttribute('aria-pressed', String(sel.length === opts.length && opts.length > 0));
      next.style.opacity = sel.length ? 1 : .45;
    };
    opts.forEach(o => o.addEventListener('click', () => { o.setAttribute('aria-pressed', String(o.getAttribute('aria-pressed') !== 'true')); sync(); }));
    if (all) all.addEventListener('click', () => { const on = all.getAttribute('aria-pressed') !== 'true'; opts.forEach(o => o.setAttribute('aria-pressed', String(on))); sync(); });
    next.addEventListener('click', () => { if (selected().length) { go(1); setTimeout(() => $('[data-quiz-name]', m).focus(), 30); } });
    $('[data-quiz-back]', m).addEventListener('click', () => go(0));

    const welcome = () => {
      const first = selected()[0];
      const name = ($('[data-quiz-name]', m).value || '').trim() || 'teammate';
      const title = (first ? first.dataset.title : fallback.title) || '';
      const line = (first ? first.dataset.line : fallback.line) || '';
      $('[data-quiz-welcome]', m).textContent = title.replace('{name}', name);
      $('[data-quiz-line]', m).textContent = line;
    };
    const restore = (pending) => {
      opts.forEach(o => o.setAttribute('aria-pressed', String((pending.reasons || []).includes(o.dataset.quizOpt))));
      sync();
      if (pending.name) $('[data-quiz-name]', m).value = pending.name;
    };
    // Let Shopify submit the form itself (it may run a spam check and reload the page).
    // We remember the answers and reopen on the welcome step when the page comes back.
    form.addEventListener('submit', () => {
      const reasons = selected().map(o => o.dataset.quizOpt);
      $('[data-quiz-tags]', m).value = ['newsletter', 'welcome-quiz'].concat(reasons.map(r => 'quiz-' + r)).join(',');
      try { sessionStorage.setItem('dyn_quiz_pending', JSON.stringify({ reasons, name: ($('[data-quiz-name]', m).value || '').trim() })); } catch (x) {}
      store.set('dyn_quiz_done', '1');
      track('quiz_submit', { reasons });
    });

    const open = (trigger) => {
      if (fired && trigger !== 'click') return;
      fired = true;
      if (trigger !== 'click') go(0);
      track('quiz_open', { trigger });
      openModal('dy-quiz');
    };
    document.addEventListener('click', (e) => { if (e.target.closest('[data-open-quiz]')) { e.preventDefault(); open('click'); } });

    // Coming back from the signup: show the welcome step (or the error) and stay open
    let pending = null;
    try { pending = JSON.parse(sessionStorage.getItem('dyn_quiz_pending') || 'null'); } catch (x) {}
    const params = new URLSearchParams(location.search);
    if (pending) {
      const hasError = !!$('[data-quiz-has-error]', m);
      if (params.get('customer_posted') === 'true' || hasError) {
        try { sessionStorage.removeItem('dyn_quiz_pending'); } catch (x) {}
        restore(pending);
        fired = true;
        if (hasError) { go(1); }
        else {
          welcome(); go(2);
          track('quiz_complete', { reasons: pending.reasons });
          try { history.replaceState(null, '', location.pathname); } catch (x) {}
        }
        openModal('dy-quiz');
        return;
      }
    }

    // Auto-open rules (Theme settings \u2192 Welcome quiz)
    if (D.designMode) return;
    const mode = cfg.mode || 'first';
    if (mode === 'off' || (mode === 'first' && store.get('dyn_quiz_done'))) return;
    if (new URLSearchParams(location.search).has('customer_posted')) return;
    if (cfg.trigger === 'delay') {
      setTimeout(() => { if (!openModals().length) open('delay'); }, (cfg.delay || 1.5) * 1000);
    } else {
      const onScroll = () => {
        const h = document.documentElement.scrollHeight - innerHeight;
        if (h > 0 && scrollY / h >= 0.5 && !openModals().length) { removeEventListener('scroll', onScroll); open('scroll'); }
      };
      addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY <= 0 && !openModals().length) open('exit'); });
    }
  }

  /* ---------- Header menu ---------- */
  function initHeader() {
    const btn = $('[data-menu-toggle]');
    const nav = $('#dy-mobile-nav');
    if (!btn || !nav) return;
    btn.addEventListener('click', () => {
      const open = nav.hidden;
      nav.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? '\u00d7' : '\u2630';
    });
  }

  /* ---------- Mobile shop bar ---------- */
  const mobileBar = $('[data-mobilebar]');
  function updateMobileBar() {
    if (!mobileBar) return;
    mobileBar.classList.toggle('is-on', scrollY > 600 && !openModals().length);
  }
  addEventListener('scroll', updateMobileBar, { passive: true });

  /* ---------- Accordions (FAQ) ---------- */
  function initAccordion(root) {
    const btns = $$('[data-acc-btn]', root);
    btns.forEach(b => b.addEventListener('click', () => {
      const open = b.getAttribute('aria-expanded') !== 'true';
      btns.forEach(x => {
        const on = x === b && open;
        x.setAttribute('aria-expanded', String(on));
        document.getElementById(x.getAttribute('aria-controls')).hidden = !on;
        x.querySelector('.faq__sign').textContent = on ? '\u2212' : '+';
      });
    }));
  }

  /* ---------- Tabs (product details) ---------- */
  function initTabs(root) {
    const tabs = $$('[role="tab"]', root);
    const pick = (t) => tabs.forEach(x => {
      const on = x === t;
      x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1;
      document.getElementById(x.getAttribute('aria-controls')).hidden = !on;
    });
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => pick(t));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        n.focus(); pick(n);
      });
    });
  }

  /* ---------- Benefits + stick ---------- */
  function initBenefits(root) {
    const items = $$('[data-benefit]', root);
    if (!items.length) return;
    const stick = $('[data-benefit-stick]', root);
    const bubble = $('[data-benefit-bubble]', root);
    const stat = $('[data-benefit-stat]', root);
    let k = 0, hold = false;
    const show = (i) => {
      k = i;
      items.forEach((b, j) => {
        const on = j === i;
        b.setAttribute('aria-expanded', String(on));
        b.style.background = on ? '#fff' : 'transparent';
        const num = $('[data-benefit-num]', b);
        num.style.background = on ? 'var(--red)' : '#fff';
        num.style.color = on ? '#fff' : 'var(--red)';
        num.style.transform = on ? 'scale(1.08)' : 'scale(1)';
        $('[data-benefit-body]', b).hidden = !on;
      });
      const b = items[i];
      stick.style.transform = b.dataset.rot;
      bubble.style.top = b.dataset.top;
      stat.textContent = b.dataset.stat;
    };
    items.forEach((b, i) => {
      ['mouseenter', 'focus', 'click'].forEach(ev => b.addEventListener(ev, () => { hold = true; if (k !== i) show(i); }));
    });
    root.addEventListener('mouseleave', () => { hold = false; });
    show(0);
    if (!reduceMotion) setInterval(() => { if (!hold && !document.hidden) show((k + 1) % items.length); }, 3800);
  }

  /* ---------- Myth or fact ---------- */
  function initMyth(card) {
    const fact = card.dataset.fact === 'true';
    $$('[data-answer]', card).forEach(b => b.addEventListener('click', () => {
      const right = (b.dataset.answer === 'true') === fact;
      $('[data-myth-ask]', card).hidden = true;
      $('[data-myth-verdict]', card).textContent = right ? card.dataset.right : card.dataset.wrong;
      $('[data-myth-result]', card).hidden = false;
    }));
  }

  /* ---------- Hormone stages ---------- */
  function initStages(root) {
    const btns = $$('.stage-btn', root);
    const e = $('[data-lvl-e]', root), p = $('[data-lvl-p]', root);
    const title = $('[data-stage-title]', root), body = $('[data-stage-body]', root);
    let swingT = null, phase = false, cur = null;
    const levels = () => {
      if (!cur) return;
      if (cur.dataset.swing === 'true') { e.style.width = phase ? '88%' : '42%'; p.style.width = phase ? '30%' : '66%'; }
      else { e.style.width = cur.dataset.e + '%'; p.style.width = cur.dataset.p + '%'; }
    };
    const pick = (b) => {
      cur = b;
      btns.forEach(x => x.setAttribute('aria-selected', String(x === b)));
      title.textContent = b.dataset.title; body.textContent = b.dataset.body;
      levels();
    };
    btns.forEach(b => b.addEventListener('click', () => pick(b)));
    pick(btns.find(b => b.getAttribute('aria-selected') === 'true') || btns[0]);
    if (!reduceMotion) swingT = setInterval(() => { phase = !phase; if (cur && cur.dataset.swing === 'true') levels(); }, 1100);
  }

  /* ---------- Ingredient tiles ---------- */
  function initIngredients(root) {
    const tiles = $$('[data-ing]', root);
    tiles.forEach(t => t.addEventListener('click', () => {
      const open = t.getAttribute('aria-expanded') !== 'true';
      tiles.forEach(x => {
        const on = x === t && open;
        x.setAttribute('aria-expanded', String(on));
        $('[data-ing-sign]', x).textContent = on ? '\u2212' : '+';
        $('[data-ing-role]', x).hidden = on;
        $('[data-ing-what]', x).hidden = !on;
      });
    }));
  }

  /* ---------- Lineup flip cards ---------- */
  function initFlip(card) {
    const inner = $('[data-flip-inner]', card);
    let t = 0;
    const set = (on) => { inner.style.transform = on ? 'rotateY(180deg)' : 'rotateY(0deg)'; card.setAttribute('aria-pressed', String(on)); };
    const isOn = () => card.getAttribute('aria-pressed') === 'true';
    card.addEventListener('mouseenter', () => { t = Date.now(); set(true); });
    card.addEventListener('mouseleave', () => set(false));
    card.addEventListener('click', () => { if (Date.now() - t < 400) return; set(!isOn()); });
    card.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); set(!isOn()); } });
  }

  /* ---------- Wingwomen filters ---------- */
  function initWingFilter(root) {
    const chips = $$('[data-ww-filter]', root);
    const select = $('[data-ww-select]', root);
    if (!chips.length && !select) return;
    const cards = $$('[data-ww]', root);
    const none = $('[data-ww-none]', root);
    const apply = (f) => {
      chips.forEach(x => x.setAttribute('aria-pressed', String(x.dataset.wwFilter === f)));
      if (select) select.value = f;
      let shown = 0;
      cards.forEach(card => {
        const vis = f === 'All' || (!card.hasAttribute('data-empty') && (card.dataset.sport || '').toLowerCase().split(',').map(s => s.trim()).includes(f.toLowerCase()));
        card.hidden = !vis; if (vis) shown++;
      });
      if (none) none.hidden = shown > 0;
    };
    chips.forEach(c => c.addEventListener('click', () => apply(c.dataset.wwFilter)));
    if (select) select.addEventListener('change', () => apply(select.value));
  }

  /* ---------- Comparison matchups ---------- */
  function initCompare(root) {
    const tabs = $$('[data-cmp-tab]', root);
    if (!tabs.length) return;
    const n = tabs.length;
    let k = 0, hold = false;
    const show = (i) => {
      k = (i + n) % n;
      tabs.forEach((t, j) => t.setAttribute('aria-selected', String(j === k)));
      $$('[data-cmp-panel]', root).forEach(p => { p.hidden = +p.dataset.cmpPanel !== k; });
    };
    const pick = (i) => { hold = true; show(i); };
    tabs.forEach((t, i) => t.addEventListener('click', () => pick(i)));
    $('[data-cmp-prev]', root).addEventListener('click', () => pick(k - 1));
    $('[data-cmp-next]', root).addEventListener('click', () => pick(k + 1));
    root.addEventListener('mouseenter', () => { hold = true; });
    root.addEventListener('mouseleave', () => { hold = false; });
    const secs = +root.dataset.interval || 0;
    if (secs > 0 && !reduceMotion && !D.designMode) setInterval(() => { if (!hold && !document.hidden) show(k + 1); }, secs * 1000);
  }

  /* ---------- Flip-card row dots (mobile) ---------- */
  function initFlipRow(row) {
    const track = $('[data-fc-track]', row);
    const dots = $$('[data-fc-dot]', row);
    if (!track || !dots.length) return;
    const n = dots.length;
    const mark = (i) => dots.forEach((d, j) => d.setAttribute('aria-current', String(j === i)));
    track.addEventListener('scroll', () => {
      const max = track.scrollWidth - track.clientWidth;
      mark(max > 0 ? Math.round(track.scrollLeft / max * (n - 1)) : 0);
    }, { passive: true });
    dots.forEach((d, i) => d.addEventListener('click', () => {
      const max = track.scrollWidth - track.clientWidth;
      track.scrollTo({ left: max * i / Math.max(1, n - 1), behavior: 'smooth' });
    }));
  }

  /* "See full label" in the product info popup */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-show-label]');
    if (!b) return;
    closeModal(b.closest('[data-modal]'));
    const g = $('[data-gallery]');
    if (!g) return;
    const thumb = $('[data-gallery-thumb="' + b.dataset.showLabel + '"]', g);
    if (thumb) thumb.click();
    g.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
  });

  /* Wingwoman application form reveal */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-apply-toggle]');
    if (!b) return;
    const f = document.getElementById(b.getAttribute('aria-controls'));
    if (!f) return;
    f.hidden = false; b.hidden = true;
    const first = $('input:not([type=hidden])', f); if (first) first.focus();
  });

  /* ---------- Boot ---------- */
  function init(scope = document) {
    $$('[data-gallery]', scope).forEach(initGallery);
    $$('[data-buybox]', scope).forEach(initBuybox);
    $$('[data-accordion]', scope).forEach(initAccordion);
    $$('[data-tabs]', scope).forEach(initTabs);
    $$('[data-benefits]', scope).forEach(initBenefits);
    $$('[data-myth]', scope).forEach(initMyth);
    $$('[data-stages]', scope).forEach(initStages);
    $$('section', scope).filter(s => $('[data-ing]', s)).forEach(initIngredients);
    $$('[data-flip]', scope).forEach(initFlip);
    $$('[data-ww-section]', scope).forEach(initWingFilter);
    $$('[data-cmp]', scope).forEach(initCompare);
    $$('[data-flip-row]', scope).forEach(initFlipRow);
  }
  document.addEventListener('DOMContentLoaded', () => {
    init();
    initHeader();
    initSticky();
    initQuiz();
    updateMobileBar();
  });
  // Re-initialize sections when edited in the theme editor
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  // Show popups while their section is selected in the theme editor
  document.addEventListener('shopify:section:select', (e) => { const m = $('[data-modal]', e.target); if (m) openModal(m.id); });
  document.addEventListener('shopify:section:deselect', (e) => { const m = $('[data-modal]', e.target); if (m) closeModal(m); });
  document.addEventListener('shopify:block:select', (e) => { const m = e.target.closest('[data-modal]'); if (m) openModal(m.id); });
})();